import { ORDER_METHODS } from '../../../../../services/exports/Constants';
import { ValidationErrors } from '../../../../../modals/order-method/types';

export default {
  title: 'Seleccionar ubicación',
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Pedido en mesa',
    [ORDER_METHODS.PICKUP]: 'Recogida',
    [ORDER_METHODS.DELIVERY]: 'Entrega',
  },
  text_inputs: {
    address: {
      placeholder: 'Busca tu dirección',
    },
    street_name: {
      placeholder: 'Calle',
    },
    street_number: {
      placeholder: 'Número',
    },
    city: {
      placeholder: 'Ciudad',
    },
    zip: {
      placeholder: 'C.P.',
    },
  },
  time_options: {
    asap: {
      title: 'Estándar',
      description: 'Listo en {{time}} min',
    },
    scheduled: {
      title: 'Programar para más tarde',
    },
  },
  time_drop_down: {
    today: 'Hoy',
  },

  pickup: {
    address: 'Dirección de recogida',
    when: '¿Cuándo?',
  },

  delivery: {
    where: '¿A dónde?',
    when: '¿Cuándo?',
    address: 'Tu dirección',
    delivery_area: 'Nuestra zona de entrega',
  },

  buttons: {
    view_menu: 'Ver menú',
    see_hours: 'Ver horario',
    next: 'Siguiente',
    change: 'Cambiar',
    save: 'Guardar',
  },

  labels: {
    when: '¿Cuándo?',
    pickup: 'Recogida en línea',
    delivery: 'Entrega',
    pickup_time: 'hora de recogida',
    delivery_time: 'hora de entrega',
    discount: 'Solo aquí {{value}} de descuento online',
    pre_orders_enabled: 'Por ahora, puedes realizar un pedido programado para más tarde',
    change_location: '← Volver al menú si prefieres otra ubicación',
    return: 'Volver',
  },

  items_dropped: {
    count_one: '{{count}} artículo eliminado',
    count_other: '{{count}} artículos eliminados',
    pickup_reason: '— no disponible para recogida.',
    delivery_reason: '— no disponible para entrega.',
  },

  error_messages: {
    [ValidationErrors.address_not_found]:
      'Lo sentimos, no encontramos esa dirección. Inténtalo de nuevo ingresando primero la calle en el campo de búsqueda.',
    [ValidationErrors.address_not_serviceable]:
      'Tu dirección está fuera de nuestra zona de entrega. ¿Deseas cambiar tu dirección o cambiar a recogida en tienda? 😊',
    [ValidationErrors.no_drivers_available]:
      'Lo sentimos, no podemos entregar en este momento. ¿Deseas pedir para recoger? 😊',
    pickup_unavailable: 'Lo sentimos, actualmente no ofrecemos recogida.',
    delivery_unavailable: 'Lo sentimos, actualmente no ofrecemos entrega.',
    delivery_paused: 'Lo sentimos, actualmente no ofrecemos entrega.',
    outside_pickup_times: 'No ofrecemos recogida en este momento. Nuestros horarios de recogida:',
    outside_delivery_times: 'No ofrecemos entrega en este momento. Nuestros horarios de entrega:',
    orders_paused_inactivity:
      'Debido a la gran demanda, no podemos aceptar más pedidos en línea ahora mismo. Por favor, pide en el local o inténtalo de nuevo en 30 minutos.',
    orders_paused_manual_end_of_day: 'Lo sentimos, estamos cerrados por el resto del día.',
    orders_paused_manual_until_time:
      'Debido a la gran demanda, no podemos aceptar más pedidos en línea ahora mismo. Por favor, pide en el local o inténtalo de nuevo a partir de {{pausedUntil}}',
    company_closed: 'Lo sentimos, no estamos abiertos en este momento.',
    pickup_closed:
      'Aceptamos pedidos de recogida hasta las {{time}} porque nuestro tiempo de preparación es de {{preparationTime}} minutos.',
    delivery_closed:
      'Aceptamos pedidos de entrega hasta las {{time}} porque nuestro tiempo de entrega es de {{preparationTime}} minutos.',
    live_orders_off: 'Lo sentimos, actualmente no podemos aceptar más pedidos en línea. Gracias por tu comprensión.',
    orders_unavailable:
      '{{type}} no está disponible en este momento. El próximo {{typeTime}} posible es el {{day}} a las {{time}}.',
  },

  no_couriers: {
    with_code:
      'Lo sentimos, no tenemos repartidores disponibles ahora mismo. Inténtalo más tarde o pide para recoger y usa el código promocional <PromoCode>{{code}}</PromoCode> al finalizar el pedido.',
    without_code:
      'Lo sentimos, no tenemos repartidores disponibles ahora mismo. Inténtalo más tarde o pide para recoger.',
    copied: 'Código promocional copiado',
  },
};
